<template>
  <div class="w-64">
    <div class="grid grid-col-1 gap-6 sticky top-0">
      <slot />
    </div>
  </div>
</template>
